import { Box, Flex, Stack, Text } from '@mantine/core'
import { useTranslations } from 'next-intl'

import Rediit from '@/assets/icons/rediit.svg'
import Tweet from '@/assets/icons/tweet.svg'
import { formatDecimal } from '@/utils/number/format'

interface OverallAllCardProps {
  redditData?: number
  twitterData?: number
}

export default function OverallAllCard({ redditData, twitterData }: OverallAllCardProps) {
  const t = useTranslations('newsCommunity')

  if (!redditData && !twitterData) return null
  return (
    <Flex
      direction="column"
      justify="center"
      h={240}
      w={190}
      style={{
        background: 'var(--bg-surface-secondary, #151D32)',
        borderRadius: 16,
        padding: 16,
        boxShadow: '0 2px 16px 0 rgba(16, 21, 34, 0.10)',
      }}
    >
      <Stack gap="xl">
        {redditData && (
          <Box>
            <Text c="var(--text-secondary)" variant="subtitle-emphasis">
              {t('redditFollowers')}
            </Text>
            <Flex align="center">
              <Rediit fill="var(--text-primary)" width={24} height={24} />
              <Text ml={4} variant="heading3" lh="32px">
                {formatDecimal(redditData)}
              </Text>
            </Flex>
          </Box>
        )}

        {twitterData && (
          <Box>
            <Text c="var(--text-secondary)" variant="subtitle-emphasis">
              {t('xFollowers')}
            </Text>
            <Flex align="center">
              <Tweet fill="var(--text-primary)" width={24} height={24} />
              <Text variant="heading3" lh="32px">
                {formatDecimal(twitterData)}
              </Text>
            </Flex>
          </Box>
        )}
      </Stack>
    </Flex>
  )
}
